import { Footer } from '@denqfabrik/landing-ui';
import { useTranslation } from '../../i18n';
import { getRoutesForLang } from '../../i18n/routes';

export default function AppFooter() {
  const { t, lang } = useTranslation();
  const prefix = `/${lang}`;
  const routes = getRoutesForLang(lang);

  return (
    <Footer
      copyright={t.footer.copyright}
      attribution={t.footer.builtBy}
      attributionHref={lang === 'de' ? 'https://denqfabrik.com' : 'https://denqfabrik.com/en'}
      links={[
        { label: t.footer.privacy, href: `${prefix}${routes.privacy}` },
        { label: t.footer.imprint, href: `${prefix}${routes.imprint}` },
      ]}
    />
  );
}
